module.exports = __webpack_public_path__ + "img/feedback1080.cdcb6ad8.jpg";